import React, { useState } from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import api from './api/client';

const ScannersInvSets = () => {
    const [scannedData, setScannedData] = useState('');
    const [entries, setEntries] = useState([]);
    const [popupMessage, setPopupMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    // const parseScannedData = (data) => {
    //     const lines = data.trim().split('\n');
    
    //     const parsedEntries = lines.map((line, index) => {
    //         const parts = line.split(',').map(part => part.trim());
    //         if (parts.length < 3) {
    //             throw new Error(`Row ${index + 1}: Incorrect data format.`);
    //         }
    
    //         const [scannerSet, sku, boxInfoAndDate] = parts;
    //         const [scannerNumber, ...setNameParts] = scannerSet.split('-');
    //         const setName = setNameParts.join('-').trim();
    
    //         const boxInfoAndDateParts = boxInfoAndDate.split(' ');
    //         if (boxInfoAndDateParts.length < 3) {
    //             throw new Error(`Row ${index + 1}: Incorrect data format BOX/DATA/TIME.`);
    //         }
    
    //         const [boxInfo, date, time] = boxInfoAndDateParts;
    //         const [boxNumber, quantity] = boxInfo.split('/');
    
    //         return {
    //             scanner: scannerNumber.trim(),
    //             setName: setName.trim(),
    //             sku: sku,
    //             boxNumber: boxNumber.replace('BOX#', '').trim(),
    //             quantity: quantity.trim(),
    //             date: date.trim(),
    //             time: time.trim()
    //         };
    //     });
    
    //     // Удаление дубликатов по SKU и Box Number
    //     const uniqueEntries = [];
    //     const seen = new Set();
    
    //     parsedEntries.forEach(entry => {
    //         const key = `${entry.sku}-${entry.boxNumber}`;
    //         if (!seen.has(key)) {
    //             seen.add(key);
    //             uniqueEntries.push(entry);
    //         }
    //     });
    
    //     return uniqueEntries;
    // };
    
    const parseScannedData = (data) => {
        const lines = data.trim().split('\n');
    
        const parsedEntries = lines.map((line, index) => {
            const parts = line.split(',').map(part => part.trim());
            if (parts.length < 3) {
                throw new Error(`Row ${index + 1}: Incorrect data format.`);
            }
    
            // Product names may contain commas — SKU and BOX/DATE are always the last two parts
            const scannerSet = parts.slice(0, -2).join(', ');
            const sku = parts[parts.length - 2];
            const boxInfoAndDate = parts[parts.length - 1];
            const [scannerNumber, ...setNameParts] = scannerSet.split('-');
            const setName = setNameParts.join('-').trim();
    
            const boxInfoAndDateParts = boxInfoAndDate.split(' ');
            if (boxInfoAndDateParts.length < 3) {
                throw new Error(`Row ${index + 1}: Incorrect data format BOX/DATA/TIME.`);
            }
    
            const [boxInfo, date, time] = boxInfoAndDateParts;
            const [boxNumber, quantity] = boxInfo.split('/');
    
            return {
                scanner: scannerNumber.trim(),
                setName: setName.trim(),
                sku: sku,
                boxNumber: boxNumber.replace('BOX#', '').trim(),
                quantity: quantity.trim(),
                date: date.trim(),
                time: time.trim(),
                isUnsealed: sku.endsWith('_U') // Дополнительное поле для unsealed boxes
            };
        });
    
        // Удаление дубликатов по SKU и Box Number
        const uniqueEntries = [];
        const seen = new Set();
    
        parsedEntries.forEach(entry => {
            const key = `${entry.sku}-${entry.boxNumber}`;
            if (!seen.has(key)) {
                seen.add(key);
                uniqueEntries.push(entry);
            }
        });
    
        return uniqueEntries;
    };
    

    const handleAddEntry = async () => {
        if (scannedData) {
            try {
                const newEntries = parseScannedData(scannedData);
                const filteredEntries = [];
    
                for (const entry of newEntries) {
                    const existsInState = entries.some(
                        (e) => e.sku === entry.sku && e.boxNumber === entry.boxNumber
                    );
    
                    if (!existsInState) {
                        const response = await api.post(`/api/check-entry`, {
                            sku: entry.sku,
                            boxNumber: entry.boxNumber,
                        });
    
                        if (response.data.exists) {
                            alert(`The record for SKU: ${entry.sku} and Box: ${entry.boxNumber} already exists in the database.`);
                        } else {
                            filteredEntries.push(entry);
                        }
                    } else {
                        alert(`Duplicate record for SKU: ${entry.sku} and Box: ${entry.boxNumber} in the current list.`);
                    }
                }
    
                setEntries((prevEntries) => [...prevEntries, ...filteredEntries]);
                setScannedData(''); // Очистить текстовое поле после успешной вставки
            } catch (error) {
                console.error(error.message);
                alert(error.message); // Показываем конкретную ошибку
            }
        }
    };
    
    

    const handleSave = async () => {
        try {
            const response = await api.post(`/api/save-boxes`, { entries });
            if (response.status === 200) {
                setPopupMessage('Success! Data saved successfully.');
            } else {
                setPopupMessage('Unexpected error! Please try again.');
            }
            setEntries([]); // Очистить данные после сохранения
        } catch (error) {
            setPopupMessage('Error! Failed to save data.');
            console.error('Save error:', error);
        } finally {
            setShowPopup(true);
            setTimeout(() => setShowPopup(false), 3000); // Попап исчезает через 3 секунды
        }
    };
    

    return (
        <div className="scanners-inv-seeds-page-bg">
            <HeaderLogged />
            <Container>
                <div className="scan-sealed-sets">
                    <h1 className="scan-sealed-sets-h">Boxes with sealed products</h1>
                    <textarea
                        value={scannedData}
                        onChange={(e) => setScannedData(e.target.value)}
                        placeholder="Please Scan the QR on the box"
                        className="scanned-input"
                    ></textarea>
                    <div>
                        <button onClick={handleAddEntry} className="add-entry-btn">Format data</button>
                        <ul className="entries-list">
                        {entries.map((entry, index) => (
                            <li key={index}>
                                <strong>Scanner: </strong> {entry.scanner}, 
                                <strong> Set Name: </strong> {entry.setName}, 
                                <strong> Box: </strong> {entry.boxNumber}, 
                                <strong> SKU: </strong> {entry.sku}, 
                                <strong> QTY: </strong> {entry.quantity}, 
                                <strong> Date: </strong> {entry.date}, 
                                <strong> Time: </strong> {entry.time}
                            </li>
                        ))}

                        </ul>
                        <button onClick={handleSave} className="save-btn">Save data</button>
                    </div>
                    

                    {showPopup && <div className="popup">{popupMessage}</div>}
                </div>
                
            </Container>

            <style jsx>{`
                .scan-sealed-sets {
                margin-top: 150px;
                z-index: 1;
                    position: relative;
                }
                .scan-sealed-sets-h {
                margin-bottom: 20px;
                color: #404340;
                text-transform: uppercase;
                font-weight: bold;
                }
                .scanned-input {
                    width: 100%;
                    height: 100px;
                    padding: 10px;
                    border: 1px solid #4caf50;
                    border-radius: 5px;
                    margin-bottom: 10px;

                    
                }

                .add-entry-btn, .save-btn {
                    background-color: #4caf50;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    margin-top: 10px;
                }

                .add-entry-btn:hover, .save-btn:hover {
                    background-color: #45a049;
                }

                .entries-list {
                    margin-top: 10px;
                    list-style-type: none;
                    padding: 0;
                }

                .entries-list li {
                    background-color: #e8f5e9;
                    padding: 10px;
                    border: 1px solid #c8e6c9;
                    border-radius: 5px;
                    margin-bottom: 5px;
                }

                .popup {
                    position: fixed;
                    bottom: 20px;
                    right: 20px;
                    background-color: #4caf50;
                    color: white;
                    padding: 10px 20px;
                    border-radius: 5px;
                }
            `}</style>
        </div>
    );
};

export default ScannersInvSets;

